module.exports = __webpack_public_path__ + "01_mole.5e1bf36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/girl/layer2/01_mole.png
// module id = p8PY
// module chunks = 0